import { supabase } from './supabase';
import { Task } from '../types/task';

export const getTasks = async (options?: { leadId?: string; createdBy?: string }): Promise<Task[]> => {
  let query = supabase
    .from('tasks')
    .select('*, leads(name)')
    .order('due_date', { ascending: true, nullsFirst: false });

  if (options?.leadId) query = query.eq('lead_id', options.leadId);
  if (options?.createdBy) query = query.eq('created_by', options.createdBy);

  const { data, error } = await query;
  if (error) { console.error('Error fetching tasks:', error); return []; }
  return (data || []).map((t: any) => ({
    ...t,
    lead_name: t.leads?.name,
  })) as Task[];
};

export const createTask = async (task: Omit<Task, 'id' | 'created_at'>): Promise<Task | null> => {
  const { data, error } = await supabase
    .from('tasks')
    .insert(task)
    .select()
    .single();
  if (error) { console.error('Error creating task:', error); return null; }
  return data as Task;
};

export const updateTask = async (id: string, updates: Partial<Task>): Promise<boolean> => {
  const { error } = await supabase.from('tasks').update(updates).eq('id', id);
  if (error) { console.error('Error updating task:', error); return false; }
  return true;
};

export const deleteTask = async (id: string): Promise<boolean> => {
  const { error } = await supabase.from('tasks').delete().eq('id', id);
  if (error) { console.error('Error deleting task:', error); return false; }
  return true;
};

export const toggleTaskComplete = async (id: string, completed: boolean): Promise<boolean> => {
  return updateTask(id, { completed });
};
